// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1any1","type":"styles_type__3O8Sz","choices":"styles_choices__2HQAH"};